export default {
  MAIN_MENU: 'ui.menu',
  FEATURE_INDIVIDUALS: 'ui.feature.individuals',
  SETTINGS: 'ui.settings',
  NOTIFICATIONS: 'ui.notifications',
  BIG_MONITOR: 'ui.monitor.bigScreen',
  BTC_MONITOR: 'ui.monitor.btc',
  REPORTS: 'ui.reports',
  REPORTS_SHIFT_PERFORMANCE: 'ui.reports.shiftPerformance',
  REPORTS_INDIVIDUALS: 'ui.reports.EmployeePerformance',
  REPORTS_WORK_PREDICTION: 'ui.reports.workPrediction',
  CHAT: 'ui.chat',
  FEATURE: 'ui.feature',
  CONTAINER: 'ui.container',
  BTC_MONITOR_LOAD_VIEW: 'ui.monitor.btc.load_view'
};

export const featureToggleType = {
  VISIBLE: 'visible',
  DISABLED: 'disabled',
  VARIANT: 'variant',
};